const CryptoJS = require("crypto-js"); //引用AES源码js
//  加密方法
export function Encrypt(word) {
  let key = CryptoJS.enc.Utf8.parse("0CoJUm6Qyw8W8jud"); //16位数作为密钥
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

//  解密方法
export function Decrypt(word) {
  let key = CryptoJS.enc.Utf8.parse("0CoJUm6Qyw8W8jud"); //16位数作为密钥
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
